import styled from 'react-emotion'

import CloudinaryS3Image from '../../CloudinaryS3Image'

import { Typo24PumpkinOrangeNBRI } from '../../../themes/Fonts/Nort'
import { Typo36WhiteTwoDI } from '../../../themes/Fonts/Din2014'
import images from '../../../themes/Images'
import Colors from '../../../themes/Colors'
import { mobile, desktop, tablet, customDevice } from '../../../utils/mixins'

import ApplyButton from '../ButtonComponent'

export const MobileContainer = styled('div')`
  background-color: ${props => (props.iplUrl ? 'rgb(0,0,5)' : null)};
  @media (min-width: 768px) {
    display: none;
  }
`

export const DesktopContainer = styled('div')`
  @media (max-width: 767px) {
    display: none;
  }
  position: relative;
`

export const MobileSectionContainer = styled('div')`
  @media (max-width: 767px) {
    min-height: 735px;
    width: auto;
    background: url(${images.layers.mobileLayer});
    background-size: cover;
    position: relative;
  }
`

export const ResponsiveContainer = styled('div')`
  @media (max-width: 767px) {
    width: 88.889%;
    margin-left: auto;
    margin-right: auto;
  }
`

export const SectionContainer = styled('div')`
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`

export const IplLogo = styled(CloudinaryS3Image)`
  @media (max-width: 767px) {
    width: 100%;
    object-fit: contain;
    padding-top: 50px;
  }
`

export const IBCLogo = styled(CloudinaryS3Image)`
  @media (max-width: 767px) {
    width: 14.286em;
    height: 12.714em;
    object-fit: contain;
    margin-bottom: 1.429em;
    margin-top: 5.143em;
  }
`

export const HeadText = styled(Typo24PumpkinOrangeNBRI)`
  @media (max-width: 767px) {
    font-size: 1.143em;
    margin-bottom: 0.25em;
  }
`

export const DescriptionText = styled(Typo36WhiteTwoDI)`
  @media (max-width: 767px) {
    font-size: 1.429em;
    text-align: center;
    margin-bottom: 0.5em;
    display: inline;
  }
`

export const TabletButtonWrapper = styled('div')`
  display: none;
  @media (min-width: 767px) and (max-width: 991px) {
    display: block;
    margin-top: 1.429em;
    margin-bottom: 80px;
  }
`

export const TabletPriceCardContainer = styled('div')`
  display: none;
  @media (min-width: 767px) and (max-width: 1023px) {
    display: block;
  }
`

export const DesktopPriceCardContainer = styled('div')`
  display: none;
  @media (min-width: 1024px) {
    display: block;
  }
`

export const ButtonWrapper = styled('div')`
  @media (max-width: 767px) {
    margin-top: 1.429em;
    margin-bottom: 80px;
  }
  ${mobile} {
    margin: 0;
    margin-top: 20px;
  }
`

export const BookButton = styled(ApplyButton)`
  width: 100%;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  ${mobile} {
    width: 40%;
    height: 40px;
    margin-left: auto;
    margin-right: auto;
    text-transform: uppercase;
    padding: 10px 10px;
    background: rgb(244, 116, 0);
  }
`

export const ButtonSupportText = styled('p')`
  font-family: din-2014;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  opacity: 0.8;
  font-size: 13px;
  font-style: italic;
  color: #ffffff;
  text-align: center;
  position: relative;
  line-height: unset;
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px;
`

export const DesktopSectionContainer = styled('div')`
  height: ${props => (props.priceCardsData ? '134vh' : '100vh')};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  ${tablet} {
    height: 100vh;
  }
  ${customDevice(1024, 1199)} {
    height: 103vh;
  }
`

export const VideoSectionContainer = styled('div')`
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: -10;
  video {
    object-fit: cover;
    width: 100%;
    height: calc(100vh + 33px);
    display: inline-block;
    vertical-align: baseline;
    ${mobile} {
      min-height: 130vh;
      padding-bottom: 30px;
    }
    ${tablet} {
      height: 100vh;
    }
    @media (min-width: 1200px) {
      height: 135vh;
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    height: calc(100vh + 33px);
    left: 0;

    ${mobile} {
      height: 100vh;
    }
    ${tablet} {
      background: url(${images.layers.tabletLayer});
      height: 100vh;
      background-size: cover;
    }
    ${desktop} {
      background: url(${images.layers.desktopLayer});
      background-size: cover;
    }
    @media (min-width: 1200px) {
      height: 135vh;
    }
  }
`

export const ContentContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 1200px) {
    margin-top: 200px;
    margin-bottom: 30px;
  }
`

export const TextContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 2.857em;
`

export const DesktopHeading = styled(Typo24PumpkinOrangeNBRI)`
  letter-spacing: 0.3px;
  margin-top: 4px;
`

export const DesktopDescription = styled(Typo36WhiteTwoDI)`
  font-size: 2.25em;
  line-height: 1.36;
  letter-spacing: 0.5px;
  color: ${Colors.whiteTwo};
  display: inline;
  margin-top: 6px;
`

export const DescriptionWrapper = styled('div')`
  @media (max-width: 767px) {
    text-align: center;
    margin-bottom: 0.714em;
  }
`

export const DesktopIbcLogo = styled(CloudinaryS3Image)`
  width: 11.143em;
  height: 10em;
  object-fit: contain;
`

export const ContentandFormWrapper = styled('div')``

export const FormWrapper = styled('div')`
  @media (max-width: 767px) {
    display: none;
  }
  ${customDevice(768, 1200)} {
    position: absolute;
    bottom: 0.375em;
    left: 0;
    width: 100%;
  }
  @media (min-width: 1200px) {
    bottom: -4.625em;
    margin-top: ${props => (props.priceCardsData ? '0' : '200px')};
  }
`

export const NowatContent = styled(Typo36WhiteTwoDI)`
  font-size: 2.25em;
  line-height: 1.67;
  letter-spacing: -0.9px;
  color: ${Colors.whiteTwo};
  display: inline;
  @media (max-width: 767px) {
    font-size: 1.429em;
    line-height: 1.5;
    letter-spacing: -0.5px;
    text-align: center;
    color: ${Colors.whiteTwo};
    text-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 0.5em;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/LandingPage/styledComponents.js